import { render, staticRenderFns } from "./ShippedDialog.vue?vue&type=template&id=1b89c458&scoped=true&lang=pug&"
import script from "./ShippedDialog.vue?vue&type=script&lang=ts&"
export * from "./ShippedDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89c458",
  null
  
)

export default component.exports